import { PropsWithChildren, useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AppBar, Box, Button, Container, Toolbar, Typography } from '@mui/material';

import { idpApi } from '../services/idp-api';

export function Layout({ children }: PropsWithChildren) {
  const location = useLocation();
  const isAccountSection = location.pathname.startsWith('/account');
  const [isSigningOut, setIsSigningOut] = useState(false);

  const handleSignOut = useCallback(async () => {
    setIsSigningOut(true);
    try {
      await idpApi.signOut();
    } finally {
      window.location.assign('/auth/signin');
    }
  }, []);

  function onSignOutClick() {
    void handleSignOut();
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static" color="transparent" elevation={0}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ fontWeight: 600, flexGrow: 1 }}>
            Ayeldo Identity
          </Typography>
          {isAccountSection && (
            <Button size="small" onClick={onSignOutClick} disabled={isSigningOut}>
              {isSigningOut ? 'Signing out...' : 'Sign out'}
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Container maxWidth="sm" sx={{ py: 4 }}>
        {children}
      </Container>
    </Box>
  );
}
